import { render, staticRenderFns } from "./DealCreationType.vue?vue&type=template&id=6fcb5f38"
import script from "./DealCreationType.vue?vue&type=script&lang=js"
export * from "./DealCreationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports